// extracted by mini-css-extract-plugin
export default {"dmSerifFont":"EnquireForm_dmSerifFont__kyQDF"};